<template>
    <div>
        <div class="row">
                    <div>
                        <el-collapse>
                            <el-collapse-item>
                                <template slot="title">
                                    <span style="color:#606266;font-size:14px;"><i
                                            class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                                </template>
                                <el-form label-position="top" label-width="100px" class="ml-0 mt-0">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Kata Kunci">
                                                <el-input type="text" id="sFilter" v-model="sFilter"
                                                    placeholder="Masukkan kata kunci" size="small"/>
                                            </el-form-item>
                                        </div>
                                        <div class="col-md-6">
                                            <el-form-item label="Status">
                                                <el-radio-group v-model="status" size="small" name="status">
                                                    <el-radio-button :label="item5.value" v-for="(item5) in options.status"
                                                        :key="item5.value" style="margin-left:0px;">{{ item5.name
                                                        }}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div class="col-md-6">
                                            <el-form-item label="Region">
                                                <el-radio-group v-model="region" size="small" name="region">
                                                    <el-radio-button :label="item5.value" v-for="(item5) in options.region"
                                                        :key="item5.value" style="margin-left:0px;">{{ item5.name
                                                        }}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div class="col-md-6">

                                        </div>
                                        <div class="col-md-6">

                                        </div>
                                        <div class="col-md-6">
                                            <el-button @click="downloadExcel">Download Excel Bukti Bayar</el-button>
                                        </div>

                                        <div class="col-md-6">

                                        </div>
                                        <div class="col-md-6">
                                            <el-date-picker
                                            type="date"
                                            v-model="FromDate"
                                            placeholder="From Date">
                                            </el-date-picker>
                                        </div>

                                        <div class="col-md-6">

                                        </div>
                                        <div class="col-md-6">
                                            <el-date-picker
                                            type="date"
                                            v-model="ToDate"
                                            placeholder="To Date">
                                            </el-date-picker>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-button type="primary" size="medium" :loading="loading.table"
                                                @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                                        </div>
                                    </div>

                                </el-form>
                            </el-collapse-item>
                        </el-collapse>
                    </div>

                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="h-100 d-flex align-items-center justify-content-center">
                                <TableBrimolaClearing reportname="ClearingList" :reportdata="reportdata"
                                    :reporturl="urlRequestParams" select_url="/plant?station=" idcol="DONO"
                                    idcol2="CustomerID" :loading="loading.table" />
                            </div>
                        </div>
                    </div>


        </div>

    </div>
</template>
<script src="https://cdn.sheetjs.com/xlsx-latest/package/dist/xlsx.full.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/file-saver@2.0.5/dist/FileSaver.min.js"></script>
<script>
import Vue from 'vue'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import LPG from '@/components/page/LPG.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import TableBrimolaClearing from '@/views/pages/TableBrimolaClearing.vue'
import { AxiosWithJar, Config, Penanggalan } from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'

export default
    {
        extends: LPG,
        components: {
            TableBrimolaClearing,
        },
        data() {
            return {
                options: {
                    status: [
                        { value: "", name: "ALL" },
                        { value: "CLEAR", name: "CLEAR" },
                        { value: "NOT CLEAR", name: "NOT CLEAR" },
                    ],
                    region:[]
                },
                sFilter: '',
                status: 'CLEAR',//this.$route.query.status ? this.$route.query.status : '',
                region: '',
                FromDate: '',
                ToDate: '',
                showmap: false,
                urlRequestParams: '',
                date: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin],
                reportdata: [],
            }
        },

        mounted() {
            this.$emit('childrenRoute');
            this.resumePilihan();
            this.loadRegion();
            console.log("mounted")
        },
        methods: {
            async downloadExcel() {
      try {


        let CFDate = '';

        if (this.FromDate) {
        const today = new Date(this.FromDate);
            if (!isNaN(today.getTime())) { // valid date check
                const yyyy = today.getFullYear();
                const mm = String(today.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
                const dd = String(today.getDate()).padStart(2, '0');
                CFDate = `${yyyy}-${mm}-${dd}`;
            }
        }
        else{
                alert("Tanggal tidak boleh kosong.");
                return;
            }

        let CLDate = '';
        if (this.ToDate) {
        const today = new Date(this.ToDate);
            if (!isNaN(today.getTime())) { // valid date check
                const yyyy = today.getFullYear();
                const mm = String(today.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
                const dd = String(today.getDate()).padStart(2, '0');
                CLDate = `${yyyy}-${mm}-${dd}`;
            }
        }
        else{
                alert("Tanggal tidak boleh kosong.");
                return;
            }



        document.body.style.cursor = 'wait';
        var url = Config().apiURL + '/v1/lpg/getBuktiBayarBrimola?';
                    url += ('&CFDate=' + CFDate);
                    url += ('&CLDate=' + CLDate);

        const response = await AxiosWithJar().get(url);
        const data = response.data.data;

        if (!Array.isArray(data) || data.length === 0) {
          alert("Data kosong.");
          return;
        }

        // Buat worksheet dan workbook menggunakan SheetJS (xlsx dari CDN)
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Bukti Bayar");

        // Convert workbook ke file dan simpan
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "bukti-bayar-brimola.xlsx");

        document.body.style.cursor = 'default';
      } catch (error) {
        document.body.style.cursor = 'default';
        console.error("Gagal download Excel:", error);
      }

    },
            async resumePilihan() {

        //         var urlRequestParams = Config().apiURL;

        //         urlRequestParams += '/v1/lpg/inserttesting?IDOrder=4998/000039/Apr/24&DONo=4998/000039/Apr/24&userLogin=uhuy';

        //                         const response = await AxiosWithJar().post(urlRequestParams);

        // if (response.data.success) {
        //   alert('✅ ' + response.data.message);
        // } else {
        //   alert('❌ ' + response.data.message);
        // }
                // const response = await fetch(Config().apiURL + '/v1/lpg/checkDO?DONo=BY41008-DO-240400055' );
                // const resultDO = await response.json();
                // console.log(resultDO.exists);
                // if(!resultDO.exists)
                // {

                // }

                this.urlRequestParams = Config().apiURL
                this.urlRequestParams += '/v1/lpg/clearing?'

                if (this.sFilter) {
                    this.urlRequestParams += ('&sFilter=' + this.sFilter);
                }
                if (this.status) {
                    this.urlRequestParams += ('&status=' + this.status);
                }
                //alert(this.region);
                if (this.region) {
                    this.urlRequestParams += ("&region=" + this.region + "");
                }
                console.log(this.region);
                this.loading.table = true;
                AxiosWithJar().get(this.urlRequestParams)
                    .then((response) => {
                        this.reportdata = response.data;
                    })
                    .catch()
                    .finally(() => {
                        this.loading.table = false;
                    })
            },
            async loadRegion() {
            try {
                this.url = Config().apiURL
                this.url += '/v1/lpg/region?'
                const response = await AxiosWithJar().get(this.url); // Ganti dengan endpoint API kamu
                console.log(response.data);
                this.options.region = [
      { value: '', name: 'ALL' },
      ...response.data.data.map(item => ({
        value: item.id,
        name: item.id // atau langsung `item.id` kalau tidak ada nama
      }))
    ];
            } catch (error) {
                //console.error('Error loading region:', error);
            }
    },
            applyFilter() {

                //alert(this.region);
                this.resumePilihan()
            },
            searchFilterButtonClick() {
                document.querySelector('li.filter').classList.toggle('down')
                var select = document.querySelectorAll('.search.form')
                Array.from(select).map((e) => { e.classList.toggle('minimize') })
            }
        }
    }
</script>
<style>
.fade-enter-active,
.fade-leave-active {
    opacity: 1;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>
